export default [
  {
    path: '/telegram-bot',
    name: 'telegramBot',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true,
      title: 'Мій Telegram-бот',
      breadcrumb: 'Мій Telegram-бот',
    },
    component: () => import('../pages/telegram-bot-page'),
  },
];
